import { put, takeLatest } from 'redux-saga/effects';
import types from 'redux/types';
import Services from 'services';
import { isResponseSuccess } from 'helpers';
import {
  AVAILABLE_COUNTRIES_URL,
  LOAD_CONFIG_URL,
  CARRIER_URL,
  PRICE_TABLE_URL,
  GET_ROUTE_LIST_URL,
} from 'consts/api';
import { showError } from 'helpers/handleError';

const {
  REQUEST_AVAILABLE_COUNTRIES,
  REQUEST_AVAILABLE_COUNTRIES_FAILED,
  REQUEST_AVAILABLE_COUNTRIES_SUCCESS,
  REQUEST_LOAD_CONFIG,
  REQUEST_LOAD_CONFIG_FAILED,
  REQUEST_LOAD_CONFIG_SUCCESS,
  REQUEST_GET_CARRIER,
  REQUEST_GET_CARRIER_SUCCESS,
  REQUEST_GET_CARRIER_FAILED,
  REQUEST_GET_TABLE_PRICE,
  REQUEST_GET_TABLE_PRICE_FAILED,
  REQUEST_GET_TABLE_PRICE_SUCCESS,
  REQUEST_ROUTE_LIST,
  REQUEST_ROUTE_LIST_FAILED,
  REQUEST_ROUTE_LIST_SUCCESS,
} = types;

function* getAvailableCountries() {
  try {
    const res = yield Services.get(AVAILABLE_COUNTRIES_URL);
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'object') {
        yield put({
          type: REQUEST_AVAILABLE_COUNTRIES_SUCCESS,
          listCountries: res.data,
        });
      }
    }
  } catch (error) {
    showError(error);
    yield put({
      type: REQUEST_AVAILABLE_COUNTRIES_FAILED,
      errorCountries: error,
    });
  }
}

function* getLoadConfig() {
  try {
    const res = yield Services.get(LOAD_CONFIG_URL);
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'object') {
        yield put({
          type: REQUEST_LOAD_CONFIG_SUCCESS,
          data: res.data,
        });
      }
    }
  } catch (error) {
    showError(error);
    yield put({
      type: REQUEST_LOAD_CONFIG_FAILED,
      errorConfig: error,
    });
  }
}

function* getCarrierList(data) {
  const { groupId, country } = data;
  try {
    const res = yield Services.get(
      `${CARRIER_URL}?groupId=${groupId || ''}&country=${country || ''}`
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res === 'object') {
        yield put({
          type: REQUEST_GET_CARRIER_SUCCESS,
          data: res.data,
        });
      }
    }
  } catch (error) {
    showError(error);
    yield put({
      type: REQUEST_GET_CARRIER_FAILED,
      error,
    });
  }
}

function* getPriceTable() {
  try {
    const res = yield Services.get(PRICE_TABLE_URL);
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'object') {
        yield put({
          type: REQUEST_GET_TABLE_PRICE_SUCCESS,
          data: res.data,
        });
      }
    }
  } catch (error) {
    showError(error);
    yield put({
      type: REQUEST_GET_TABLE_PRICE_FAILED,
      error,
    });
  }
}

function* getRouteList() {
  try {
    const res = yield Services.get(GET_ROUTE_LIST_URL);
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'object') {
        yield put({
          type: REQUEST_ROUTE_LIST_SUCCESS,
          data: res.data,
        });
      }
    }
  } catch (error) {
    showError(error);
    yield put({
      type: REQUEST_ROUTE_LIST_FAILED,
      error,
    });
  }
}

export default function* watchAPIFunction() {
  yield takeLatest(REQUEST_AVAILABLE_COUNTRIES, getAvailableCountries);
  yield takeLatest(REQUEST_LOAD_CONFIG, getLoadConfig);
  yield takeLatest(REQUEST_GET_CARRIER, getCarrierList);
  yield takeLatest(REQUEST_GET_TABLE_PRICE, getPriceTable);
  yield takeLatest(REQUEST_ROUTE_LIST, getRouteList);
}
